export default {
  scrollBehavior(to, _from, savedPosition) {
    if (to.hash) {
      const rootElement = document.documentElement;
      const headerHeight = getComputedStyle(rootElement)?.getPropertyValue("--header-height");
      const headerHeightValue = parseInt(headerHeight, 10) || 0;
      const position = { el: to.hash, top: headerHeightValue };
      return position;
    }
    if (savedPosition)
      return savedPosition;
    if (to.params.savePosition)
      return {};
    return { top: 0, left: 0 };
  }
};
